import FolderUpload from "./Components/FolderUpload"

const Index = () =>
{
    return(
        <div>
           <FolderUpload/>
        </div>
    )
}
export default Index